import { render, staticRenderFns } from "./AddEditModerator.vue?vue&type=template&id=62e15a95"
import script from "./AddEditModerator.vue?vue&type=script&lang=js"
export * from "./AddEditModerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports